<mat-sidenav-container class="console">
  <mat-sidenav
    class="console-sidenav"
    [mode]="sidenavMode()"
    [opened]="sidenavOpen()"
    (closedStart)="onSidenavClosed()"
  >
    <div class="brand">
      <img src="assets/img/logo_esteso_positivo.svg" alt="Parkingless" />
    </div>

    <mat-nav-list>
      <a mat-list-item [routerLink]="garageAdminPath" routerLinkActive="active">
        <mat-icon matListItemIcon>garage</mat-icon>
        <span matListItemTitle>I miei Garage</span>
      </a>
    </mat-nav-list>

    @if (selectedGarage(); as garage) {
      <!--
        The pages of the selected garage only. Every screen in this console queries one
        garage at a time, so a sidebar listing all of them at once was offering
        navigation the data model does not have.
      -->
      <div class="nav-section">
        <span class="nav-section-label">{{ garage.name }}</span>
      </div>

      <mat-nav-list class="garage-nav">
        @for (item of menu(); track item.path) {
          <a mat-list-item [routerLink]="item.path" routerLinkActive="active">
            <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
            <span matListItemTitle>{{ item.title }}</span>
          </a>
        }
      </mat-nav-list>
    } @else if (hasGarages()) {
      <p class="no-garage">Seleziona un garage dal menu in alto.</p>
    } @else {
      <p class="no-garage">Nessun garage disponibile</p>
    }

    <mat-nav-list class="sidenav-footer">
      <a mat-list-item [routerLink]="supportPath" routerLinkActive="active">
        <mat-icon matListItemIcon>support_agent</mat-icon>
        <span matListItemTitle>Contattaci</span>
      </a>
      <p class="console-version" data-testid="console-version">v{{ consoleVersion }}</p>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <mat-toolbar class="console-toolbar">
      <button mat-icon-button (click)="toggleSidenav()" aria-label="Apri o chiudi il menu">
        <mat-icon>menu</mat-icon>
      </button>

      <!--
        Which garage you are looking at is the single most important piece of state in
        this console, and it used to appear only as a card subtitle halfway down the
        page. Here it is context and switcher at once.
      -->
      <!--
        Which garage you are working in, and the only place to change it. This is the
        console's primary scope control, so it stays in the header on every route —
        including the garage-less ones, where it is how you get back into a garage.
      -->
      @if (hasGarages()) {
        <button mat-button class="garage-switch" [matMenuTriggerFor]="garageMenu">
          <mat-icon>local_parking</mat-icon>
          @if (selectedGarage(); as garage) {
            <span class="garage-switch-name">{{ garage.name }}</span>
          } @else {
            <span class="garage-switch-name is-empty">Seleziona un garage</span>
          }
          <mat-icon class="garage-switch-caret">expand_more</mat-icon>
        </button>
        <mat-menu #garageMenu="matMenu">
          @for (option of garageOptions(); track option.garageId) {
            <a mat-menu-item [routerLink]="option.link">
              <mat-icon>
                {{ option.garageId === selectedGarage()?.garageId ? 'check' : 'local_parking' }}
              </mat-icon>
              <span>{{ option.name }}</span>
            </a>
          }
          <a mat-menu-item [routerLink]="garageAdminPath">
            <mat-icon>grid_view</mat-icon>
            <span>Tutti i garage</span>
          </a>
        </mat-menu>
      }

      <span class="flex-spacer"></span>

      <app-amount-toggle />
      <app-notification-bell />

      @if (user$ | async; as user) {
        <button mat-button class="user-button" [matMenuTriggerFor]="userMenu">
          <mat-icon>account_circle</mat-icon>
          <span class="user-name">{{ user.displayName || user.email }}</span>
        </button>
        <mat-menu #userMenu="matMenu">
          <a mat-menu-item [routerLink]="userProfilePath">
            <mat-icon>person</mat-icon>
            <span>Profilo Utente</span>
          </a>
          <button mat-menu-item (click)="signOut()">
            <mat-icon>logout</mat-icon>
            <span>Esci</span>
          </button>
        </mat-menu>
      }
    </mat-toolbar>

    <app-license-banner [notice]="licenseNotice()" [hideAction]="onPurchasePage()" />

    @if (loader.isLoading()) {
      <mat-progress-bar mode="indeterminate" />
    }

    <main class="console-content">
      <router-outlet />
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>
